export const convertTo12HourTimeCompact = (time24) => {
  const [hour, minute] = time24.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return minute === 0
    ? `${hour12} ${period}`
    : `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
};
